import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {

  private accessTokenSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('access_token')
  );

  private refreshTokenSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('refresh_token')
  );

  /* ================= ACCESS TOKEN ================= */

  getAccessToken(): string | null {
    return this.accessTokenSubject.value;
  }

  setAccessToken(token: string): void {
    localStorage.setItem('access_token', token);
    this.accessTokenSubject.next(token);
  }

  /* ================= REFRESH TOKEN ================= */

  getRefreshToken(): string | null {
    return this.refreshTokenSubject.value;
  }

  setRefreshToken(token: string): void {
    localStorage.setItem('refresh_token', token);
    this.refreshTokenSubject.next(token);
  }

  /* ================= BOTH TOKENS ================= */

  setTokens(accessToken: string, refreshToken: string): void {
    this.setAccessToken(accessToken);
    this.setRefreshToken(refreshToken);
  }

  clearAll(): void {
    localStorage.clear();
    this.accessTokenSubject.next(null);
    this.refreshTokenSubject.next(null);
  }

  /* ================= LOGIN CHECK ================= */

  isLoggedIn(): boolean {
    return !!this.getAccessToken();
  }

  /* ================= USER ================= */

  get user(): any | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;

    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }

  set user(value: any | null) {
    if (!value) {
      localStorage.removeItem('user');
    } else {
      localStorage.setItem('user', JSON.stringify(value));
    }
  }
}
